import { isFluidEnabledForSource, FluidOwaSource } from 'owa-fluid-validations';
import {
    lazyUpdateCalendarEventCollabSpace,
    lazyIsCollabSpacePresent,
} from 'owa-calendar-collaborative-space';
import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export async function updateCollabSpace(event: CalendarEvent, viewStateId: string) {
    if (isFluidEnabledForSource(FluidOwaSource.CalendarCompose)) {
        const isCollabSpacePresent = await lazyIsCollabSpacePresent.importAndExecute(viewStateId);
        if (isCollabSpacePresent || event.CollabSpace) {
            await lazyUpdateCalendarEventCollabSpace.importAndExecute(event, viewStateId);
        }
    }
}
